import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges
} from "@angular/core";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { ApiUrlConstant } from "./../../../shared/constants/api-url.constant";
import { WidgetConfig } from "../../../shared/class/widget-config";
import { ChartConfig } from "../../../shared/class/chart-config";
addMore(Highcharts);
import { DynamicPipe } from './../../../shared/directives/dynamic.pipe';

export class DataOptions {
  constructor(
    public api: string,
    public xAxis: Array<any>,
    public yAxis: Array<any>,
    public title: string,
    public dataText: string,
    public legend: Array<any>
  ) { }
}

@Component({
  selector: "app-dummy-page",
  templateUrl: "./dummy-page.component.html",
  styleUrls: ["./dummy-page.component.scss"],
  providers: [DynamicPipe]
})
export class DummyPageComponent implements OnInit {
  dropdownItems = ["All"];
  highcharts: typeof Highcharts = Highcharts;
  chartOptions = null;
  errorMessage = "";
  mockChart = null;
  Alldata;
  widgetConfigs: WidgetConfig[] = [
    /**{
      title: "Reasons for Failure",
      api: this.apiUrl.DELHIVERY_PERFORMANCE_OVERALL_TREND_REASON_FAILURE,
      id: 3,
      widgetType: "pie-chart"
    },
    {
      title: "Reasons for Failure",
      api: this.apiUrl.OVERALL_PERFORMANCE_INWARD_REASON_FAILURE,
      id: 13,
      widgetType: "pie-chart"
    },
    {
      title: "Reasons for Failure",
      api: this.apiUrl.OVERALL_PERFORMANCE_RETURN_REASON_FAILURE,
      id: 17,
      widgetType: "pie-chart"
    },
    {
      title: "Reasons for Failure",
      api: this.apiUrl.OVERALL_PERFORMANCE_TRANSFER_REASON_FAILURE,
      id: 9,
      widgetType: "pie-chart"
    }, //line -chart 12 2 16 24 7 20
    {
      title: "End To End SLA Trends",
      api: this.apiUrl.OVERALL_PERFORMANCE_INWARD_E2E_SLA_TRENDS,
      id: 12,
      widgetType: "line-chart"
    },
    {
      title: "SLA Trends",
      api: this.apiUrl.DELHIVERY_PERFORMANCE_OVERALL_TREND,
      id: 2,
      widgetType: "line-chart"
    },
    {
      title: "End To End SLA Trends",
      api: this.apiUrl.OVERALL_PERFORMANCE_RETURN_E2E_SLA_TREND,
      id: 16,
      widgetType: "line-chart"
    },
    {
      title: "Transport SLA Trend",
      api: this.apiUrl.TRANSPORTATION_SLA_TREND,
      id: 24,
      widgetType: "line-chart"
    },
    {
      title: "End To End SLA Trends",
      api: this.apiUrl.OVERALL_PERFORMANCE_TRANSFER_E2E_SLA_TRENDS,
      id: 7,
      widgetType: "line-chart"
    },
    {
      title: "Warehouse SLA Trend",
      api: this.apiUrl.WAREHOUSE_SLA_TREND,
      id: 20,
      widgetType: "line-chart"
    },
    {
      title: "Most Affected Customers",
      api: this.apiUrl.DELHIVERY_PERFORMANCE_MOST_AFFECTED_CUSTOMERS,
      id: 6,
      config: {"query": 7},
      widgetType: "simple-table"
    },
    {
      title: "PERFORMANCE.DELIVERY.MOST_AFFECTED_STATES",
      api: this.apiUrl.DELHIVERY_PERFORMANCE_MOST_AFFECTED_STATES,
      id: 5,
      config: {"query": 7},
      widgetType: "simple-table"
    },
    {
      title: "PERFORMANCE.INWARD.WORST_OD_PAIRS",
      api: this.apiUrl.OVERALL_PERFORMANCE_INWARD_WORST_OD_PAIRS,
      id: 14,
      config: {"query": 7},
      widgetType: "simple-table"
    },
    {
      title: "WAREHOUSE.MOST_AFFECTED_WAREHOUSES",
      api: this.apiUrl.WAREHOUSE_MOST_AFFECTED_WAREHOUSES,
      id: 21,
      config: {"query": 6},
      widgetType: "simple-table"
    },
    {
      title: "HEADING_TEXT.TRANSPORTATION_MOST_AFFECTED_OD_PAIRS",
      api: this.apiUrl.TRANSPORTATION_MAX_OD,
      id: 25,
      config: {"query": 6},
      widgetType: "simple-table"
    },
    {
      title: "PERFORMANCE.RETURN.WORST_OD_PAIRS",
      api: this.apiUrl.OVERAL_PERFORMANCE_RETURN_WORST_OD_PAIRS,
      id: 18,
      config: {"query": 7},
      widgetType: "simple-table"
    },
    {
      title: "PERFORMANCE.TRANSFER.WORST_OD_PAIRS",
      api: this.apiUrl.OVERALL_PERFORMANCE_TRANSFER_WORST_OD_PAIRS,
      id: 10,
      config: {"query": 7},
      widgetType: "simple-table"
    },

    {
      title: "PERFORMANCE.DELIVERY.END_TO_END_SLA",
      api: this.apiUrl.GET_DELIVERY_END_2_END_SLA,
      id: 29,
      widgetType: "dual-column-chart"
    },
    {
      title: "TRANSPORTATION.END_TO_END_SLA",
      api: this.apiUrl.TRANSPORTATION_SLA,
      id: 23,
      widgetType: "dual-column-chart"
    },
    {
      title: "PERFORMANCE.INWARD.END_TO_END_SLA",
      api: this.apiUrl.OVERALL_PERFORMANCE_INWARD_E2E_SLA,
      id: 11,
      widgetType: "dual-column-chart"
    },
    {
      title: "PERFORMANCE.TRANSFER.END_TO_END_SLA",
      api: this.apiUrl.OVERALL_PERFORMANCE_RETURN_E2E_SLA,
      id: 15,
      widgetType: "dual-column-chart"
    },
    {
      title: "PERFORMANCE.RETURN.END_TO_END_SLA",
      api: this.apiUrl.OVERALL_PERFORMANCE_TRANSFER_E2E_SLA,
      id: 7,
      widgetType: "dual-column-chart"
    },
    {
      title: "WAREHOUSE.WAREHOUSE_SLA",
      api: this.apiUrl.WAREHOUSE_SLA,
      id: 19,
      widgetType: "dual-column-chart"
    },
    {
      title: "WAREHOUSE.WAREHOUSE_UTILIZATION",
      api: this.apiUrl.WAREHOUSE_UTILIZATION,
      id: 22,
      widgetType: "dual-column-chart"
    }**/
    {
      title: "HEADING_TEXT.TRANSPORTATION_POD_AVAILBLITY",
      api: this.apiUrl.TRANSPORTATION_POD_AVAIL,
      id: 27,
      widgetType: "area-chart"
    },
    {
      title: "HEADING_TEXT.TAT_BREAKUP",
      api: this.apiUrl.TRANSPORTATION_POD,
      id: 26,
      widgetType: "stacked-column-chart"
    }
  ];

  chartConfigs = [
    /** [ //widget = 3
       {
         title: {
           text: "Failed SLA orders",
           fontSize: "",
           fontColor: "",
           fontWeight: ""
         },
         xAxis: { text: "", fontSize: "", fontColor: "", fontWeight: "" },
         yAxis: [{ text: "", fontSize: "", fontColor: "", fontWeight: "" }],
         legend: {
           colorSet: ["#EBC844", "#73C8B1", "#F4902D"],
           enabled: true,
           fontColor: "#6b778c",
           fontWeight: "normal"
         }
       }
     ],
     [ // widget = 13
       {
         title: {
           text: "Failed SLA orders",
           fontSize: "",
           fontColor: "",
           fontWeight: ""
         },
         xAxis: { text: "", fontSize: "", fontColor: "", fontWeight: "" },
         yAxis: [{ text: "", fontSize: "", fontColor: "", fontWeight: "" }],
         legend: { colorSet: [], enabled: true, fontColor: "", fontWeight: "" }
       }
     ],
     [ // widget = 17
       {
         title: {
           text: "Failed SLA orders",
           fontSize: "",
           fontColor: "",
           fontWeight: ""
         },
         xAxis: { text: "", fontSize: "", fontColor: "", fontWeight: "" },
         yAxis: [{ text: "", fontSize: "", fontColor: "", fontWeight: "" }],
         legend: { colorSet: [], enabled: true, fontColor: "", fontWeight: "" }
       }
     ],
     [ // widget = 9
       {
         title: {
           text: "Failed SLA orders",
           fontSize: "",
           fontColor: "",
           fontWeight: ""
         },
         xAxis: { text: "", fontSize: "", fontColor: "", fontWeight: "" },
         yAxis: [{ text: "", fontSize: "", fontColor: "", fontWeight: "" }],
         legend: { colorSet: [], enabled: true, fontColor: "", fontWeight: "" }
       }
     ], // Line Chart
     [
       {
         // widget = 12
 
         xAxis: {
           text: "",
           style: { fontSize: "", fontColor: "", fontWeight: "" }
         },
         yAxis: [
           {
             title: {
               text: "SLA",
               style: { fontSize: "", fontColor: "", fontWeight: "" }
             },
             label: {
               format: "{value}%",
               style: { fontSize: "12px", fontColor: "", fontWeight: "" }
             },
             min: 0,
             max: 125
           },
           {
             title: {
               text: "Quantity (Units)",
               style: { fontSize: "", fontColor: "", fontWeight: "" }
             },
             label: {
               format: "{value}",
               style: { fontSize: "12px", fontColor: "", fontWeight: "" }
             },
             min: 0,
             max: 0
           }
         ],
         legend: {
           style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
           enabled: true,
           colorSet: ["#3985df", "#909dc0", "#979797"]
         },
         series: {
           name: ["SLA", "Quantity", "Target"],
           tooltipSuffix: ["%"]
         }
       }
     ],
     [
       {
         // widget = 2
 
         xAxis: {
           text: "",
           style: { fontSize: "", fontColor: "", fontWeight: "" }
         },
         yAxis: [
           {
             title: {
               text: "Percentage",
               style: { fontSize: "", fontColor: "", fontWeight: "" }
             },
             label: {
               format: "{value}%",
               style: { fontSize: "12px", fontColor: "", fontWeight: "" }
             },
             min: 0,
             max: 110
           },
           {
             title: {
               text: "Quantity (Units)",
               style: { fontSize: "", fontColor: "", fontWeight: "" }
             },
             label: {
               format: "{value}",
               style: { fontSize: "12px", fontColor: "", fontWeight: "" }
             },
             min: 0,
             max: 0
           }
         ],
         legend: {
           style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
           enabled: true,
           colorSet: ["#3985df", "#909dc0"]
         },
         series: {
           name: ["SLA", "Quantity"],
           tooltipSuffix: ["%"]
         },
         noTarget: true
       }
     ],
     [
       {
         // widget = 16
 
         xAxis: {
           text: "",
           style: { fontSize: "", fontColor: "", fontWeight: "" }
         },
         yAxis: [
           {
             title: {
               text: "SLA",
               style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
             },
             label: {
               format: "{value}%",
               style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
             },
             min: 0,
             max: 125
           },
           {
             title: {
               text: "Quantity (Units)",
               style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
             },
             label: {
               format: "{value}",
               style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
             },
             min: 0,
             max: 0
           }
         ],
         legend: {
           style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
           enabled: true,
           colorSet: ["#3985df", "#909dc0", "#979797"]
         },
         series: {
           name: ["SLA", "Quantity"],
           tooltipSuffix: ["%", "crore"]
         }
       }
     ],
     [
       {
         // widget = 24
 
         xAxis: {
           text: "",
           style: { fontSize: "", fontColor: "", fontWeight: "" }
         },
         yAxis: [
           {
             title: {
               text: "SLA",
               style: { fontSize: "12px", fontColor: "#666", fontWeight: "" }
             },
             label: {
               format: "{value}%",
               style: { fontSize: "12px", fontColor: "#666", fontWeight: "" }
             },
             min: 0,
             max: 125
           },
           {
             title: {
               text: "Quantity (Units)",
               style: { fontSize: "12px", fontColor: "#666", fontWeight: "" }
             },
             label: {
               format: "{value}",
               style: { fontSize: "12px", fontColor: "#666", fontWeight: "" }
             },
             min: 0,
             max: 0
           }
         ],
         legend: {
           style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
           enabled: true,
           colorSet: ["#3985df", "#909dc0", "#979797"]
         },
         series: {
           name: ["SLA", "Quantity"],
           tooltipSuffix: ["%", "crore"]
         }
       }
     ],
     [
       {
         // widget = 8
 
         xAxis: {
           text: "",
           style: { fontSize: "", fontColor: "", fontWeight: "" }
         },
         yAxis: [
           {
             title: {
               text: "Percentage",
               style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
             },
             label: {
               format: "{value}%",
               style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
             },
             min: 0,
             max: 125
           },
           {
             title: {
               text: "Quantity (Units)",
               style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
             },
             label: {
               format: "{value}",
               style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
             },
             min: 0,
             max: 0
           }
         ],
         legend: {
           style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
           enabled: true,
           colorSet: ["#3985df", "#909dc0", "#979797"]
         },
         series: {
           name: ["SLA", "Quantity", "Target"],
           tooltipSuffix: ["%", "crore"]
         }
       }
     ],
     [ // widget = 20
       {
         xAxis: {
           text: "",
           style: { fontSize: "", fontColor: "", fontWeight: "" }
         },
         yAxis: [
           {
             title: {
               text: "Percentage",
               style: { fontSize: "12px", fontColor: "", fontWeight: "" }
             },
             label: {
               format: "{value}%",
               style: { fontSize: "12px", fontColor: "", fontWeight: "" }
             },
             min: 0,
             max: 125
           },
           {
             title: {
               text: "Quantity (Units)",
               style: { fontSize: "12px", fontColor: "", fontWeight: "" }
             },
             label: {
               format: "{value}",
               style: { fontSize: "12px", fontColor: "", fontWeight: "" }
             },
             min: 0,
             max: 0
           }
         ],
         legend: {
           style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
           enabled: true,
           colorSet: ["#3985df", "#909dc0", "#979797"]
         },
         series: {
           name: ["SLA", "Quantity", "Target"],
           tooltipSuffix: ["%"]
         }
       }
     ],
     [ // widget = 6
       {
         label: "Customer",
         key: "client_name",
         operations: "",
         postfix: "",
         prefix: "",
         pipes: []
       },
       {
         label: "SLA",
         key: "otif",
         operations: "",
         postfix: "%",
         prefix: "",
         pipes: ['number: 1.1-1']
       },
       {
         label: "Value",
         key: "value",
         postfix: "",
         prefix: "",
         operations: "",
         pipes: ['amountIndianUnits']
       },
       {
         label: "Quantity",
         key: "quantity",
         operations: "",
         postfix: "",
         prefix: "",
         pipes: []
       }
     ],
     [ // widget = 5
       {
         label: "Areas",
         key: "state",
         operations: "",
         postfix: "",
         prefix: "",
         pipes: []
       },
       {
         label: "SLA",
         key: "otif",
         operations: "",
         postfix: "%",
         prefix: "",
         pipes: ['number: 1.1-1']
       },
       {
         label: "Value",
         key: "value",
         postfix: "",
         prefix: "",
         operations: "",
         pipes: ['amountIndianUnits']
       },
       {
         label: "Quantity",
         key: "quantity",
         operations: "",
         postfix: "",
         prefix: "",
         pipes: []
       }
     ],
     [ // widget = 14
       {
         label: "WH",
         key: "pair",
         operations: "",
         postfix: "",
         prefix: "",
         pipes: []
       },
       {
         label: "SLA",
         key: "otif",
         operations: "",
         postfix: "%",
         prefix: "",
         pipes: ['number: 1.1-1']
       },
       {
         label: "Value",
         key: "value",
         postfix: "",
         prefix: "",
         operations: "",
         pipes: ['amountIndianUnits']
       },
       {
         label: "Quantity",
         key: "quantity",
         operations: "",
         postfix: "",
         prefix: "",
         pipes: []
       }
     ],
     [ // widget id= 21
       {
         label: "Warehouse",
         key: "client_fc_name",
         operations: "",
         postfix: "",
         prefix: "",
         pipes: []
       },
       {
         label: "WH Type",
         key: "client_fc_type",
         operations: "",
         postfix: "",
         prefix: "",
         pipes: []
       },
       {
         label: "SLA %",
         key: "value",
         postfix: "%",
         prefix: "",
         operations: "data.sla * 100",
         pipes: ['number: 1.1-1']
       },
       {
         label: "Value",
         key: "total_value",
         operations: "",
         postfix: "",
         prefix: "",
         pipes: []
       },
       {
         label: "Quantity",
         key: "total_quantity",
         operations: "",
         postfix: "",
         prefix: "",
         pipes: []
       }
     ],
     [ // widget = 25
       {
         label: "WH",
         key: "origin_city",
         operations: "",
         postfix: "",
         prefix: "",
         pipes: []
       },
       {
         label: "SLA %'",
         key: "",
         operations: "row.sla * 100",
         postfix: "%",
         prefix: "",
         pipes: ["number: 1.1-1"]
       },
       {
         label: "Value",
         key: "total_value",
         postfix: "",
         prefix: "",
         operations: "",
         pipes: []
       },
       {
         label: "Value",
         key: "total_value",
         operations: "",
         postfix: "",
         prefix: "",
         pipes: []
       }
     ],
     [ // widget = 18
       {
         label: "WH",
         key: "origin_city",
         operations: "",
         postfix: "",
         prefix: "",
         pipes: []
       },
       {
         label: "SLA %'",
         key: "",
         operations: "row.sla * 100",
         postfix: "%",
         prefix: "",
         pipes: ["number: 1.1-1"]
       },
       {
         label: "Value",
         key: "total_value",
         postfix: "",
         prefix: "",
         operations: "",
         pipes: []
       },
       {
         label: "Value",
         key: "total_value",
         operations: "",
         postfix: "",
         prefix: "",
         pipes: []
       }
     ],
     [ // widget = 10
       {
         label: "WH",
         key: "pair",
         operations: "",
         postfix: "",
         prefix: "",
         pipes: []
       },
       {
         label: "SLA'",
         key: "otif",
         operations: "",
         postfix: "%",
         prefix: "",
         pipes: ["number: 1.1-1"]
       },
       {
         label: "Value",
         key: "value",
         postfix: "",
         prefix: "",
         operations: "",
         pipes: []
       },
       {
         label: "Quantity",
         key: "quantity",
         operations: "",
         postfix: "",
         prefix: "",
         pipes: []
       }
     ],
    [ // widget = 29
      {
        chartWidth: 3,
        xAxis: {
          text: "",
          style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
        },
        yAxis: [
          {
            title: {
              text: "Percentage",
              style: { fontSize: "9px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}%",
              style: { fontSize: "9px", fontColor: "#626262", fontWeight: "" }
            }
          },
          {
            title: {
              text: "Quantity (Units)",
              style: { fontSize: "9px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}",
              style: { fontSize: "9px", fontColor: "#626262", fontWeight: "" }
            }
          }
        ],
        legend: {
          style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
          enabled: true,
          colorSet: ["#007FD8", "#c6cdd4", "#909dc0"]

        },
        series: {
          name: ["SLA", "Under Process", "Delivered"],
          tooltipSuffix: ["%", " (Units)", " (Units)"],
          stack: ["A", "B", "B"]
        }
      },
      {
        chartWidth: 9,
        xAxis: {
          text: "",
          style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
        },
        yAxis: [
          {
            title: {
              text: "Percentage",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}%",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            }
          },
          {
            title: {
              text: "Quantity (Units)",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            }
          }
        ],
        legend: {
          style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
          enabled: true,
          colorSet: ["#007FD8", "#c6cdd4", "#909dc0"],
          text: ["SLA", "Under Process Quantity", "Delivered Quantity"]

        },
        series: {
          name: ["SLA", "Under Process", "Delivered"],
          tooltipSuffix: ["%", " (Units)", " (Units)"],
          stack: ["A", "B", "B"]
        },
        noTarget: true
      }
    ],
    [ // widget = 23
      {
        chartWidth: 3,
        xAxis: {
          text: "",
          style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
        },
        yAxis: [
          {
            title: {
              text: "Percentage",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}%",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            }
          }
        ],
        legend: {
          style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
          enabled: true,
          colorSet: ["#C6CDD4", "#007FD8"],

        },
        series: {
          name: ["Under Process", "SLA"],
          tooltipSuffix: [],
          stack: ["A", "A"]
        }
      },
      {
        chartWidth: 9,
        xAxis: {
          text: "",
          style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
        },
        yAxis: [
          {
            title: {
              text: "Percentage",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}%",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            }
          },
          {
            title: {
              text: "Quantity (Units)",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            }
          }
        ],
        legend: {
          style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
          enabled: true,
          colorSet: ["#C6CDD4", "#007FD8", "#909dc0"],
          text: ["", "SLA", "Quantity"]

        },
        series: {
          name: ["Under Process", "SLA", "Quantity"],
          tooltipSuffix: ["%", "%", " (Units)"],
          stack: ["A", "A", "B"]
        },
        noTarget: false
      }
    ],
    [ // widget = 11
      {
        chartWidth: 3,
        xAxis: {
          text: "",
          style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
        },
        yAxis: [
          {
            title: {
              text: "Percentage",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}%",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            }
          }
        ],
        legend: {
          style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
          enabled: false,
          colorSet: ["#C6CDD4", "#007FD8"],

        },
        series: {
          name: ["Under Process", "SLA"],
          tooltipSuffix: [],
          stack: ["A", "A"]
        }
      },
      {
        chartWidth: 9,
        xAxis: {
          text: "",
          style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
        },
        yAxis: [
          {
            title: {
              text: "Percentage",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}%",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            }
          },
          {
            title: {
              text: "Quantity (Units)",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            }
          }
        ],
        legend: {
          style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
          enabled: false,
          colorSet: ["#C6CDD4", "#007FD8", "#909dc0"],
          text: ["", "SLA", "Quantity"]

        },
        series: {
          name: ["Under Process", "SLA", "Quantity"],
          tooltipSuffix: ["%", "%", " (Units)"],
          stack: ["A", "A", "B"]
        },
        noTarget: false
      }
    ],
    [ // widget = 15
      {
        chartWidth: 3,
        xAxis: {
          text: "",
          style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
        },
        yAxis: [
          {
            title: {
              text: "Percentage",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}%",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            }
          }
        ],
        legend: {
          style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
          enabled: false,
          colorSet: ["#C6CDD4", "#007FD8"],

        },
        series: {
          name: ["Under Process", "SLA"],
          tooltipSuffix: [],
          stack: ["A", "A"]
        }
      },
      {
        chartWidth: 9,
        xAxis: {
          text: "",
          style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
        },
        yAxis: [
          {
            min: 0,
            max: 110,
            title: {
              text: "Percentage",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}%",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            }
          },
          {
            title: {
              text: "Quantity (Units)",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            }
          }
        ],
        legend: {
          style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
          enabled: false,
          colorSet: ["#C6CDD4", "#007FD8", "#909dc0"],
          text: ["", "SLA", "Quantity"]

        },
        series: {
          name: ["Under Process", "SLA", "Quantity"],
          tooltipSuffix: ["%", "%", " (Units)"],
          stack: ["A", "A", "B"]
        },
        noTarget: false
      }
    ],
    [ // widget = 7
      {
        chartWidth: 3,
        xAxis: {
          text: "",
          style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
        },
        yAxis: [
          {
            min: 0,
            max: 125,
            title: {
              text: "Percentage",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}%",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            }
          }
        ],
        legend: {
          style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
          enabled: false,
          colorSet: ["#C6CDD4", "#007FD8"],

        },
        series: {
          name: ["Under Process", "SLA"],
          tooltipSuffix: [],
          stack: ["A", "A"]
        }
      },
      {
        chartWidth: 9,
        xAxis: {
          text: "",
          style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
        },
        yAxis: [
          {
            title: {
              text: "Percentage",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}%",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            }
          },
          {
            title: {
              text: "Quantity (Units)",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            }
          }
        ],
        legend: {
          style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
          enabled: false,
          colorSet: ["#C6CDD4", "#007FD8", "#909dc0"],
          text: ["", "SLA", "Quantity"]

        },
        series: {
          name: ["Under Process", "SLA", "Quantity"],
          tooltipSuffix: ["%", "%", " (Units)"],
          stack: ["A", "A", "B"]
        },
        noTarget: false
      }
    ],
    [ // widget = 19
      {
        chartWidth: 3,
        xAxis: {
          text: "",
          style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
        },
        yAxis: [
          {
            min: 0,
            max: 125,
            title: {
              text: "Percentage",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}%",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            }
          }
        ],
        legend: {
          style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
          enabled: false,
          colorSet: ["#007FD8"],

        },
        series: {
          name: [, "SLA"],
          tooltipSuffix: [""],
          stack: ["A"]
        }
      },
      {
        chartWidth: 9,
        xAxis: {
          text: "",
          style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
        },
        yAxis: [
          {
            title: {
              text: "Percentage",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}%",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            }
          },
          {
            title: {
              text: "Quantity (Units)",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            }
          }
        ],
        legend: {
          style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
          enabled: false,
          colorSet: ["#007FD8", "#909dc0"],
          text: ["", "SLA", "Quantity"]

        },
        series: {
          name: ["SLA", "Quantity"],
          tooltipSuffix: ["%", "%", " (Units)"],
          stack: ["A", "B"]
        },
        noTarget: false
      }
    ],
    [ // widget = 22
      {
        chartWidth: 3,
        xAxis: {
          text: "",
          style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
        },
        yAxis: [
          {
            min: 0,
            max: 125,
            title: {
              text: "Percentage",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}%",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            }
          }
        ],
        legend: {
          style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
          enabled: false,
          colorSet: ["#007FD8"],

        },
        series: {
          name: ["Utilized"],
          tooltipSuffix: [""],
          stack: ["A"]
        }
      },
      {
        chartWidth: 9,
        xAxis: {
          text: "",
          style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
        },
        yAxis: [
          {
            title: {
              text: "Percentage",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}%",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            }
          },
          {
            title: {
              text: "Storage capacity (Thousand Cubic Feet)",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            },
            label: {
              format: "{value}",
              style: { fontSize: "12px", fontColor: "#626262", fontWeight: "" }
            }
          }
        ],
        legend: {
          style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
          enabled: false,
          colorSet: ["#c6cdd4", "#007FD8", "#909dc0"],
          text: [ "Available", "Utilized", "Total Capacity" ]

        },
        series: {
          name: ["Available", "Utilized", "Total Capacity"],
          tooltipSuffix: ["%", "%", ""],
          stack: ["A", "A", "B"]
        },
        noTarget: false
      }
    ]**/

    [
      {
        // widget = 27
        xAxis: {
          text: "",
          style: { fontSize: "12px", fontColor: "", fontWeight: "" }
        },
        yAxis: [
          {
            title: {
              text: "Percentage",
              style: { fontSize: "12px", fontColor: "", fontWeight: "" }
            },
            label: {
              format: "{value}%",
              style: { fontSize: "12px", fontColor: "", fontWeight: "" }
            }
          }
        ],
        legend: {
          style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
          enabled: true,
          colorSet: ["#8bc9fb", "#007fd8"]
        },
        series: {
          name: ["Hard copy", "Soft copy"],
          tooltipSuffix: []
        }
      }
    ],
    [
      {
        // widget = 26
        xAxis: {
          text: "",
          style: { fontSize: "12px", fontColor: "", fontWeight: "" }
        },
        yAxis: [
          {
            title: {
              text: "Percentage",
              style: { fontSize: "12px", fontColor: "", fontWeight: "" }
            },
            label: {
              format: "{value}%",
              style: { fontSize: "12px", fontColor: "", fontWeight: "" }
            }
          }
        ],
        legend: {
          style: { fontSize: "", fontColor: "#6b778c", fontWeight: "normal" },
          enabled: true,
          colorSet: ["#ebc844", "#73c8b1", "#f58f0e", "#00afe3"]
        },
        series: {
          name: ["1 day", "2 day", "3 day", "> 3 day"],
          tooltipSuffix: ["%", "%", "%", "%"],
          index: [3, 2, 1, 0]
        }
      }
    ]

  ];

  constructor(private apiUrl: ApiUrlConstant) { }

  ngOnInit() { }
}
